import Airports from "./Airports";

export default Airports;